export const initCheckBox = () => {
	const checkBoxes = document.querySelectorAll('.js-checkbox');

	checkBoxes.forEach((checkBox) => {
		const input = checkBox.querySelector('input');

		input.addEventListener('change', () => {
			if (!input.validity.valueMissing) {
				input.setCustomValidity('');
				checkBox.classList.add('is-valid');
				checkBox.classList.remove('is-invalid');
			}

			input.checkValidity();
		});

		input.addEventListener('invalid', () => {
			checkBox.classList.add('is-invalid');
			checkBox.classList.remove('is-valid');
			input.setCustomValidity('Vink dit selectievakje aan als je wilt doorgaan.');
		});
	});
};
